export const WIDGET_REQUEST = "WIDGET_REQUEST";
export const WIDGET_UPDATE = "WIDGET_UPDATE";
export const WIDGET_UPDATED = "WIDGET_UPDATED";
export const WIDGET_DELETE = "WIDGET_DELETE";
export const WIDGET_CREATE = "WIDGET_CREATE";
export const WIDGET_VERIFY = "WIDGET_VERIFY";
export const WIDGET_ERROR = "WIDGET_ERROR";
export const WIDGET_LOADED = "WIDGET_LOADED";
